import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { putDeleteContractEndpoint } from '../../../common/endpoints';

export const putDeleteContractData = createApi(putDeleteContractEndpoint, 'PUT');

const DeleteContracts = createSlice({
  name: 'DeleteContracts',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putDeleteContractData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putDeleteContractData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putDeleteContractData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeleteContracts.reducer;